<template>
  <div>
    <div class="Header-Wrapper">
      <simple-header :label="$t('global.back')" @click="goBack" />
    </div>
    <vv-box :title="$t('progression.myProgression')">
      <div class="vv-box-progression display-flex display-column">

        <mq-layout :mq="['tablet', 'desktop']" class="mq-header header-not-mobile">
          <div class="progression-detail-header">
            <progress-circle :isRouteDetail="this.isRouteDetail"
                            :isMobile="false"
                            :percentage="this.themePercentage"
                            :color="this.themeColor"
                            :image="'http:'+this.badgeImage()"
                            :changeImgSuccess="false">
            </progress-circle>

            <div class="progression-detail-header-title">
              <h2>{{ this.theme.title }}</h2>
              {{ $t('shop.lesson-details.authorPrefix') }}<br>
              <h3 class="italic">
                <span class="author-name">{{ authorName }}</span><br>
              </h3>
              {{ authorJob }}
            </div>

            <progress-circle :isRouteDetail="this.isRouteDetail"
                          :isMobile="false"
                          :isLocked="!this.isComplete"
                          :percentage="100"
                          :color="this.themeColor"
                          :image="'http:'+this.badgeImage()"
                          :changeImgSuccess="true">
            </progress-circle>
          </div>
        </mq-layout>

        <mq-layout :mq="['mobile']" class="mq-header header-mobile">
          <div class="progression-detail-header">
            <div class="progression-detail-header-title">
              <h2>{{ this.theme.title }}</h2>
              {{ $t('shop.lesson-details.authorPrefix') }}<br>
              <h3 class="italic">
                <span class="author-name">{{ authorName }}</span><br>
              </h3>
              {{ authorJob }}
            </div>
            <div class="progession-circles">
              <progress-circle :isRouteDetail="this.isRouteDetail"
                              :isMobile="true"
                              :percentage="this.themePercentage"
                              :color="this.themeColor"
                              :image="'http:'+this.badgeImage()"
                              :changeImgSuccess="false">
              </progress-circle>
              <progress-circle :isRouteDetail="this.isRouteDetail"
                              :isMobile="true"
                              :isLocked="!this.isComplete"
                              :percentage="this.themePercentage"
                              :color="this.themeColor"
                              :image="'http:'+this.badgeImage()"
                              :changeImgSuccess="true">
              </progress-circle>
            </div>
            <div class="mobile-subtitle">
              <div class="mobile-subtitle-badge mobile-subtitle-item">
                <h4 v-if="badge">{{ this.badge.title }}</h4>
                <h4 v-else> BADGE A FAIRE</h4>
              </div>
              <!-- <div class="mobile-subtitle-space"></div> -->
              <div class="mobile-subtitle-percent mobile-subtitle-item">
                <h4>{{ $t('userAccount.progression') }}</h4>
              </div>
            </div>
          </div>
        </mq-layout>

        <div class="progression-detail-content">
          <div class="progression-detail-content-header">
            <u class="pdch">Quiz</u>
          </div>
          <div class="progression-detail-content-list display-flex display-row">
            <div class="progression-detail-content-list-item display-flex display-column"
               v-for="lessonStep in lessonsStepsQuiz" :key="lessonStep.id"
               @click="generateRandomQuizAndOpenIt(lessonStep.quizId)">
              <progress-circle :isLesson="true"
                              :isRouteDetail="false"
                              :percentage="100"
                              :isComplete="quizzComplete(lessonStep.quizId)"
                              :image="getStarImg(lessonStep.quizId)"
                              :changeImgSuccess="true">
              </progress-circle>
              <h3>{{ quizName(lessonStep.quizId) }}</h3>
            </div>

            <div v-if="hasQuiz()" class="progression-detail-content-list-item display-flex display-column">
              <div v-if="!successQuiz()" class="progression-detail-content-list-item-super">
                <a class="progession-has-quiz" type="button" @click="generateAndOpenQuiz()">
                  <progress-circle :isLesson="true"
                                  :isRouteDetail="false"
                                  :percentage="100"
                                  :isComplete="false"
                                  :image="getCupImg()"
                                  :changeImgSuccess="true">
                  </progress-circle>
                  </a>
                <h3>{{ this.superQuiz() }}</h3>
              </div>
              <div v-if="successQuiz()" class="progression-detail-content-list-item-super">
                <a class="progession-has-quiz" type="button" @click="generateAndOpenQuiz()">
                  <progress-circle :isLesson="true"
                                  :isRouteDetail="false"
                                  :percentage="100"
                                  :isComplete="true"
                                  :image="getCupImg()"
                                  :changeImgSuccess="true">
                  </progress-circle>
                </a>
                <h3>{{ this.superQuiz() }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vv-box>
  </div>
</template>

<script>

import badgeMixin from '@/mixins/badge'
import { VvBox, VvButton } from '@/components/common'
import SimpleHeader from '@/components/navigation/SimpleHeader.vue'
import ProgressCircle from '@/components/userAccount/ProgressCircle'

import { GENERATE_RANDOM_QUIZ, SET_COMING_FROM_PROGRESSION} from '@/store/modules/quiz/types'
import { contentHasQuiz } from '@/store/modules/quiz/actions'
import remoteConfigMixin from '@/mixins/remoteConfig'

import { getThemePercentageQuiz, getThemeColor } from '@/helpers/userCompletion'

export default {
  name: 'UserProgressionDetail',
  components: { VvBox, ProgressCircle, VvButton, SimpleHeader },
  mixins: [badgeMixin, remoteConfigMixin],
  computed: {
    theme() {
      return this.$store.getters.currentTheme
    },
    themePercentage() {
      return getThemePercentageQuiz(this.theme.id)
    },
    themeColor(themeId) {
      return getThemeColor(this.theme.id)
    },
    isComplete() {
      return this.successQuiz() ? true : false
    },
    isRouteDetail() {
      return this.$route.name == 'userProgressionDetail' ? true : false
    },
    lessonsSteps() {
      return this.$store.getters.currentThemeLessonSteps
    },
    lessonsStepsQuiz() {
      return this.lessonsSteps.filter(l => l.quizId)
    },
    badge() {
      return this._getBadgeFromMasterclass(this.theme.id)
    },
    authorName() {
      return this.theme.author.fullName
    },
    authorImagee() {
      return this.theme.author.image
    },
    authorJob() {
      return this.theme.author.job
    },
    authorDesc() {
      return this.theme.author.description
    },
  },
  mounted() {

    // set coming from progression = false
    this.$store.commit(SET_COMING_FROM_PROGRESSION, false)
  },
  methods: {
    hasQuiz() {
      return contentHasQuiz('masterclass', this.theme.id, this.$store.state)
    },
    successQuiz() {
      // Check that the masterclass badge is in the acquired badges
      return this.hasQuiz() && this.badge && this.acquiredBadges.indexOf(this.badge.id) > -1 ? true : false
    },
    superQuiz() {
      if (!this.badge) return "Quiz Final"
      return this.successQuiz() ? "Vous êtes " + this.badge.title : "Devenez " + this.badge.title
    },
    badgeImage() {
      return this.badge ? this.badge.image : this.theme.tileImage
    },
    generateRandomQuizAndOpenIt(quizId) {
      if (!this.remoteConfig.getBoolean('quiz_enabled')) return

      localStorage.setItem('masterclassId', this.theme.id)

      this.$store.dispatch(GENERATE_RANDOM_QUIZ, { 
        contentType: 'quiz',
        contentId: quizId
      })

      this.$store.commit(SET_COMING_FROM_PROGRESSION, true)

      this.$router.push({
        name: 'quiz',
        params: {
          contentType: 'quiz',
          contentId: quizId,
          quizId: quizId
        }
      })
    },
    generateAndOpenQuiz() {
      if (!this.remoteConfig.getBoolean('quiz_enabled')) return
      if (!this.isAllQuizComplete()) return
      
      localStorage.setItem('masterclassId', this.theme.id)
      
      this.$store.dispatch(GENERATE_RANDOM_QUIZ, {
        contentType: 'masterclass',
        contentId: this.theme.id
      })
      
      this.$store.commit(SET_COMING_FROM_PROGRESSION, true)

      this.$router.push({
        name: 'quiz',
        params: {
          quizId: this.theme.id,
          contentType: 'masterclass',
          contentId: this.theme.id
        }

      })
    },
    
    quizName(quizId) {
      const quiz = this.$store.getters.quizById(quizId)
      return quiz ? quiz.name : ''
    },
    isAllQuizComplete() {
      let validated = 0
      for (let idx = 0; this.lessonsStepsQuiz.length != idx; idx +=1) {
        validated += this.quizzComplete(this.lessonsStepsQuiz[idx].quizId) ? 1 : 0
      }
      return this.lessonsStepsQuiz.length == validated
    },
    quizzComplete(quizzId = null) {
      const result = this.$store.getters.quizResultByQuiz(this.$store.getters.quizById(quizzId))
      return result >= 50.0 ? true : false
    },
    getStarImg(quizzId = null) {
      if (quizzId && this.quizzComplete(quizzId) == true) return require('@/assets/bxs-star.png')
      else return require('@/assets/bxs-star-1.png')
    },
    getCupImg() {
      if (this.hasQuiz() && this.successQuiz()) return require('@/assets/cup-gold.png')
      else return require('@/assets/cup-grey.png')
    },
    goBack() {
      this.$router.push({ name: 'userProgression' })
    }
  } 
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/responsive.scss';

.vv-box-progression {
  display: flex;
  align-items: center;
  justify-content: center;

  .progression-detail-header, .progression-detail-content {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin: 10px;

    .pdch {
      font-size: 20px;
    }

    .progression-detail-header-title { 
      text-align: center;
      padding-right: 10px;

      .author-name {
        color: #D33551;
      }

      h2 {
        margin-top: 96px;
        font-size: 30px;

        @include for-size(tablet-portrait-down) {
          margin-top: 66px;
        }
      }

      h3 {
        margin-top: -3px;
        font: normal normal normal 30px/40px Caveat;
        letter-spacing: 0px;
        margin-bottom: -4px;
      }

      
    }
    .mobile-subtitle {
      display: flex;
      justify-content: space-evenly;
      flex-direction: row;
      width: 100%;

      .mobile-subtitle-space {
        margin-left: 35px;
      }

      .mobile-subtitle-badge {
        display: flex;
        align-self: center;
        justify-content: center;
      }

      .mobile-subtitle-percent {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .mobile-subtitle-item {
        width: 50%;
        text-align: center;
      }

      h4 {
        padding-right: 10px;
      }
    } 
  }

  .progression-detail-header {
    align-items: flex-start;
    margin: 0;
    margin-right: 20px;

    // margin-top: 139px; // decomment to use maquette pixel size

    // @include for-size(tablet-landscape-down) {
    //   flex-direction: column;
    //   align-items: center;
    //   // & > :first-child { // decomment to remove first progress circle in tablet-landscape-down
    //   //   display: none;
    //   // }
    // }
  }

  .progression-detail-content {
    flex-direction: column;
    width: 100%;
    
    .progression-detail-content-header {
      color: #D10D4A;
      font: normal normal normal 15px/25px Helvetica Neue;
      margin-top: 50px;
      margin-bottom: -30px;
    }

    .progression-detail-content-list {
      margin-top: 40px;
      width: 70%;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;

      @include for-size(phone-only) {
        width: 100% !important;
      }

      .progression-detail-content-list-item {
        width: 30%;
        justify-content: center;
        align-items: center;
        flex-grow: 1;
        flex-shrink: 1;
        padding: 0 10px 0 10px;

        @include for-size(tablet-landscape-down) {
          width: 50% !important;
          margin-bottom: 20px;
        }

        h3 {
          text-align: center;
          width: 100%;
          height: 40px;
        }
      }

      .progression-detail-content-list-item-super {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .progression-detail-content-list-item:hover {
        cursor: pointer;
      }
    }
  }

  .vv-button-progression {
    transition: background-color 250ms ease-in-out;
    -webkit-transition: background-color 250ms ease-in-out;
  }

  .vv-button-progression:hover{
    background-color: #D00E4A;
    color: $font-button;
  }
}

.arrow-down {
  display: inline-block;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}

.progession-has-quiz {
  cursor: pointer;
}

.mq-header {
  width: 100%;

  &.header-mobile {

    .progression-detail-header {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: -20px;
    }
    .progession-circles {
      display: flex;
      width: 100%;
      flex-direction: row-reverse;
      justify-content: space-around;
      padding-right: 10px;
      margin-top: 20px;
    }

    .progression-detail-header-title {
      margin-top: -40px;
    }
  }
}
</style>
